import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
} from "@mui/material";
import request from "../../../../../../../utilities/requests";

const YesNoQuestion = ({ questionData, userId }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [choice, setChoice] = React.useState(null);
  const [changed, setChanged] = React.useState(false);

  React.useEffect(() => {
    setChoice(questionData?.answer?.value);
  }, [questionData]);

  const handleSave = async () => {
    const body = {
      questionId: questionData._id,
      answer: choice,
      userId
    }
    const result = await request("matchmaking/answer", "post", body);
    if (result.success) {
      setChanged(false);
    }
  };

  return (
    <Grid item xs={12}>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item md={6} xs={12}>
            <Typography>{question?.question}</Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <RadioGroup row>
              <FormControlLabel
                value="yes"
                control={
                  <Radio
                    onChange={() => {
                      setChoice("yes");
                      setChanged(true);
                    }}
                    checked={choice === "yes" ? true : false}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={
                  <Radio
                    onChange={() => {
                      setChoice("no");
                      setChanged(true);
                    }}
                    checked={choice === "no" ? true : false}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </Grid>

          {changed ? (
            <Grid item xs={12} md={2}>
              <Button variant="contained" onClick={handleSave}>
                save
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default YesNoQuestion;
